import React from "react";

const UserPermissionsContext = React.createContext();
export default UserPermissionsContext;
